import React, { useEffect, useReducer, useState } from 'react';

import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { ReactComponent as NegativeIcon } from '../../../../assets/img/icon/Negative.svg';
import { ReactComponent as PositiveIcon } from '../../../../assets/img/icon/Positive.svg';
import FloatingButton from '../../../../components/FloatingButton';
import { NumberFormatCustom } from '../../../../components/NumberFormartCustom/NumberFormatCustom.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';
import sinisterReducer, {
  ADD_INJURED_PEOPLE,
  UPDATE_INJURED_PEOPLE,
} from '../../../../context/sinister/sinister.reducer';
import useForm from '../../../../helpers/useForm';
import InjuredValidations from './InjuredPersons.validations';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
    },
  })
);

const injuredCount: any = {
  0: 'Primer lesionado',
  1: 'Segundo lesionado',
  2: 'Tercer lesionado',
  3: 'Cuarto lesionado',
  4: 'Quinto lesionado',
  5: 'Sexto lesionado',
};

const InjuredPersons = () => {
  const classes = useStyles();

  const { nextStep, sinister_body, updateSinisterBody } =
    useSinisterDataContext();

  const [initialValues] = useState({
    numeric_errors: [],
    injured_people: sinister_body?.crash?.involved?.injureds || [],
  });

  const [state, dispatch] = useReducer(sinisterReducer, initialValues);
  const [open, setOpen] = useState(false);

  const [injuredPersons, setInjuredPersons] = useState(
    sinister_body?.crash?.involved?.amount || 1
  );
  const [injuredPersonsData, setInjuredPersonsData] = useState(
    sinister_body?.crash?.involved?.have_data_third || false
  );
  const [legalAssistance, setLegalAssistance] = useState(
    sinister_body?.crash?.involved?.legal_assistance_needed || false
  );

  const peopleOn: { [index: string]: any } = {
    type: 'familiar',
  };

  const callNextStep = () => {
    updateSinisterBody({
      crash: {
        ...sinister_body.crash,
        involved: {
          ...sinister_body.crash?.involved,
          amount: injuredPersons,
          have_data_third: injuredPersonsData,
          injureds: injuredPersonsData ? state.injured_people : [],
          legal_assistance_needed: legalAssistance,
        },
      },
    });
    nextStep();
  };

  const { errors } = useForm(callNextStep, InjuredValidations);

  const handleAddPeople = () => {
    let item = peopleOn;
    dispatch({
      type: ADD_INJURED_PEOPLE,
      payload: item,
    });
  };

  const handlePeople = (event: any, i: any) => {
    const item = state.injured_people[i] || {};
    item[event.target.name] = event.target.value;
    dispatch({
      type: UPDATE_INJURED_PEOPLE,
      payload: { index: i, value: item },
    });
  };

  const handleNumbers = (event: any, i: any) => {
    const regex = /^[0-9]+$/;
    const item = state.injured_people[i] || {};

    if (regex.test(event.target.value)) {
      item[event.target.name] = event.target.value;
      dispatch({
        type: UPDATE_INJURED_PEOPLE,
        payload: item,
      });
    }
  };

  const handleCheckbox = (i: any) => {
    const item = state.injured_people[i] || {};

    if (item.type === 'no_familiar') {
      item.type = 'familiar';
      dispatch({
        type: UPDATE_INJURED_PEOPLE,
        payload: item,
      });
    } else {
      item.type = 'no_familiar';
      dispatch({
        type: UPDATE_INJURED_PEOPLE,
        payload: item,
      });
    }
  };

  const handleSexCheckbox = (i: any) => {
    const item = state.injured_people[i] || {};

    if (item.sex === 'Male') {
      item.sex = 'Female';
      dispatch({
        type: UPDATE_INJURED_PEOPLE,
        payload: item,
      });
    } else {
      item.sex = 'Male';
      dispatch({
        type: UPDATE_INJURED_PEOPLE,
        payload: item,
      });
    }
  };

  const handleInjuredData = (checked: any) => {
    if (state.injured_people.length === 0) {
      let item = peopleOn;
      dispatch({
        type: ADD_INJURED_PEOPLE,
        payload: item,
      });
    }
    setInjuredPersonsData(checked);
  };

  const handleDelete = (i: any) => {
    const item = state.injured_people.splice(i, 1) || {};

    dispatch({
      type: UPDATE_INJURED_PEOPLE,
      payload: item,
    });
  };

  useEffect(() => {
    if (injuredPersonsData && state.injured_people.length > injuredPersons) {
      setOpen(true);
      setInjuredPersons(injuredPersons + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [injuredPersons]);

  const getform = () => {
    const { injured_people } = state;
    return injured_people.map((element: any, i: any) => (
      <Grid key={i} container justify="center">
        <Grid item xs={12}>
          <Box my={4}>
            <Typography
              variant="h6"
              style={{ fontFamily: 'Inter', color: '#000' }}
            >
              ¿Qué relación tenés con el afectado?
            </Typography>
          </Box>
        </Grid>
        <Box className={classes.root}>
          <Accordion defaultExpanded={true}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography style={{ fontFamily: 'Inter', color: '#000' }}>
                {injuredCount[i]}
              </Typography>
            </AccordionSummary>
            <Grid item xs={12}>
              <AccordionDetails style={{ display: 'block' }}>
                <Grid item xs={12}>
                  <Box my={2}>
                    <FormControl
                      component="fieldset"
                      style={{ display: 'block' }}
                    >
                      <FormGroup aria-label="position" row>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={element.type === 'no_familiar'}
                              color="primary"
                              onChange={() => handleCheckbox(i)}
                            />
                          }
                          label="No familiar"
                          name="indirectRelative"
                          id="indirectRelative"
                          value="no_familiar"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={element.type === 'familiar'}
                              color="primary"
                              onChange={() => handleCheckbox(i)}
                            />
                          }
                          label="Familiar directo"
                          name="DirectRelavie"
                          id="DirectRelavie"
                          value="familiar"
                        />
                      </FormGroup>
                      <Box display="grid" justifyContent="flex-end">
                        <Button
                          color="secondary"
                          onClick={() => handleDelete(i)}
                        >
                          <Typography color="secondary"> Eliminar </Typography>
                        </Button>
                      </Box>
                    </FormControl>
                  </Box>
                </Grid>
                {element.type === 'no_familiar' && (
                  <Box>
                    <Grid item xs={12}>
                      <Box mr={2} my={2}>
                        <Typography variant="subtitle2">
                          {' '}
                          Nombre y apellido{' '}
                        </Typography>
                        <TextField
                          size="small"
                          error={!!errors['full_name']}
                          helperText={errors['full_name']}
                          onChange={(event) => handlePeople(event, i)}
                          fullWidth={true}
                          name="full_name"
                          id="full_name"
                          placeholder="Ingresá nombre y apellido"
                          variant="outlined"
                          defaultValue={element.full_name}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box mr={2} my={2}>
                        <Typography variant="subtitle2">
                          {' '}
                          Nº de documento{' '}
                        </Typography>
                        <TextField
                          InputProps={{
                            inputComponent: NumberFormatCustom as any,
                          }}
                          size="small"
                          error={Boolean(errors['identification_number'])}
                          helperText={errors['identification_number']}
                          onChange={(event) => handleNumbers(event, i)}
                          fullWidth={true}
                          name="identification_number"
                          id="identification_number"
                          placeholder="Ingresá tu número de documento"
                          variant="outlined"
                          defaultValue={element.identification_number}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box mr={2} my={2}>
                        <Typography variant="subtitle2"> Edad </Typography>
                        <TextField
                          InputProps={{
                            inputComponent: NumberFormatCustom as any,
                          }}
                          size="small"
                          error={!!errors['age']}
                          helperText={errors['age']}
                          onChange={(event) => handleNumbers(event, i)}
                          fullWidth={true}
                          name="age"
                          id="age"
                          placeholder="Ingresá tu edad"
                          variant="outlined"
                          defaultValue={element.age}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box mr={2} my={2}>
                        <Typography variant="subtitle2"> Teléfono </Typography>
                        <TextField
                          InputProps={{
                            inputComponent: NumberFormatCustom as any,
                          }}
                          type="tel"
                          size="small"
                          onChange={(event) => handleNumbers(event, i)}
                          fullWidth={true}
                          // error={Boolean(numericErrors[i]["phone"])}
                          // helperText={numericErrors[i]["phone"]}
                          name="contact_phone"
                          id="contact_phone"
                          placeholder="Ingresá tu número de documento"
                          variant="outlined"
                          value={element.contact_phone}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box my={2}>
                        <FormControl component="fieldset">
                          <Typography variant="subtitle2">Sexo *</Typography>
                          <FormGroup aria-label="position" row>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={element.sex === 'Male'}
                                  onChange={() => handleSexCheckbox(i)}
                                  color="primary"
                                />
                              }
                              label="Masculino"
                              name="sex"
                              id="indirectRelative"
                              value="Male"
                              onChange={(event) => handlePeople(event, i)}
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={element.sex === 'Female'}
                                  onChange={() => handleSexCheckbox(i)}
                                  color="primary"
                                />
                              }
                              label="Femenino"
                              name="sex"
                              id="DirectRelavie"
                              value="Female"
                              onChange={(event) => handlePeople(event, i)}
                            />
                          </FormGroup>
                        </FormControl>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box mr={2} my={2}>
                        <FormControl component="fieldset">
                          <RadioGroup
                            name={'vehicle_injured'}
                            aria-label="has"
                            value={element.vehicle_injured || ''}
                            onChange={(event) => handlePeople(event, i)}
                            row
                          >
                            {/* owner / vehicle_third / pedestrian */}
                            <FormControlLabel
                              value={'owner'}
                              control={<Radio />}
                              label="Vehículo propio"
                            />
                            <FormControlLabel
                              value={'vehicle_third'}
                              control={<Radio />}
                              label="Vehículo de tercero"
                            />
                            <FormControlLabel
                              value={'pedestrian'}
                              control={<Radio />}
                              label="Peatón"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    </Grid>
                    {element.vehicle_injured === 'vehicle_third' && (
                      <Grid item xs={12}>
                        <Box mr={2} my={2}>
                          <FormControl
                            fullWidth
                            size="small"
                            variant="outlined"
                          >
                            <Typography variant="subtitle1">
                              Tipo de vehículo
                            </Typography>
                            <Select
                              variant="outlined"
                              aria-label="vehicle-data"
                              name="vehicle_third"
                              id="vehicle_third"
                              value={element.vehicle_third || ''}
                              onChange={(event) => handlePeople(event, i)}
                            >
                              <MenuItem
                                style={{ color: '#000' }}
                                value=" "
                                disabled
                              >
                                {' '}
                                Seleccioná el vehículo{' '}
                              </MenuItem>
                              <MenuItem
                                style={{ color: '#000' }}
                                value={'vehicle'}
                              >
                                {' '}
                                Vehículo{' '}
                              </MenuItem>
                              <MenuItem
                                style={{ color: '#000' }}
                                value={'motorcycle'}
                              >
                                {' '}
                                Motociclista{' '}
                              </MenuItem>
                              <MenuItem
                                style={{ color: '#000' }}
                                value={'byke'}
                              >
                                {' '}
                                Ciclista{' '}
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Box mr={2} my={2}>
                        <TextField
                          size="small"
                          multiline
                          rows={6}
                          error={element.description > 1333}
                          helperText={
                            element.description > 1333 &&
                            'La descripción de la lesión no debería superar los 1333 caracteres'
                          }
                          onChange={(event) => handlePeople(event, i)}
                          fullWidth={true}
                          name="description"
                          id="description"
                          placeholder="Descripción de la lesión *"
                          variant="outlined"
                          defaultValue={element.description}
                        />
                      </Box>
                    </Grid>
                  </Box>
                )}
              </AccordionDetails>
            </Grid>
          </Accordion>
        </Box>
      </Grid>
    ));
  };

  return (
    <>
      <SharedDialog
        open={open}
        onClose={() => setOpen(false)}
        content={
          <Box>
            <Typography variant="h6">
              {' '}
              Los datos de los afectados supera la cantidad de lesionados{' '}
            </Typography>
            <Box my={2}>
              <Typography>
                Por favor agregue más personas involucradas o elimine los datos
                de uno o más afectados
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box m={2} display="flex" alignItems="center">
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={() => setOpen(false)}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <form>
        <Grid container>
          <Grid container>
            <Grid item xs={12}>
              <Box my={4}>
                <Typography
                  variant="h6"
                  style={{ fontFamily: 'Inter', color: '#000' }}
                >
                  ¿Cuántas personas se lesionaron?
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box>
                <Typography variant="caption"> Lesionados </Typography>
                <Box
                  style={{
                    border: '1px solid #E7E7E7',
                    display: 'table',
                    borderRadius: '5px',
                  }}
                >
                  <IconButton
                    color="secondary"
                    onClick={() =>
                      setInjuredPersons(
                        injuredPersons === 0
                          ? injuredPersons
                          : injuredPersons - 1
                      )
                    }
                  >
                    <NegativeIcon />
                  </IconButton>
                  {injuredPersons}
                  <IconButton
                    color="secondary"
                    onClick={() =>
                      injuredPersons === 6
                        ? injuredPersons
                        : setInjuredPersons(injuredPersons + 1)
                    }
                  >
                    <PositiveIcon />
                  </IconButton>
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Grid item lg={12}>
            <Box ml={4} my={2}>
              <FormControl component="fieldset">
                <FormGroup aria-label="position">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={legalAssistance}
                        color="primary"
                        onChange={(event) =>
                          setLegalAssistance(event.target.checked)
                        }
                      />
                    }
                    label="Necesito asistencia legal"
                    name="legal_assistance"
                    id="legal_assistance"
                  />
                  <Box mt={-1} ml={4}>
                    <Typography variant="caption">
                      {' '}
                      Solo para heridos de gravedad{' '}
                    </Typography>
                  </Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={injuredPersonsData}
                        color="primary"
                        onChange={(event) =>
                          handleInjuredData(event.target.checked)
                        }
                      />
                    }
                    label="Tengo datos de los afectados"
                    name="injured_persons_data"
                    id="injured_persons_data"
                  />
                </FormGroup>
              </FormControl>
            </Box>
          </Grid>

          {injuredPersonsData && getform()}

          <Grid container justify="center">
            {injuredPersonsData &&
              state.injured_people.length < injuredPersons && (
                <Grid item xs={12}>
                  <Box
                    my={4}
                    alignItems="center"
                    justifyContent="center"
                    display="flex"
                  >
                    <Button color="secondary" onClick={handleAddPeople}>
                      + Agregar otra persona lesionada
                    </Button>
                  </Box>
                </Grid>
              )}

            <Grid item xs={12} sm={6}>
              <FloatingButton
                disabled={
                  !injuredPersonsData
                    ? injuredPersons <= 0
                    : sinister_body.injured_people_amount <= 0 ||
                      injuredPersons <= 0 ||
                      state.injured_people.find(
                        (people: any) =>
                          !people.sex && people.type === 'no_familiar'
                      ) ||
                      injuredPersons > state.injured_people.length ||
                      state.injured_people.length > injuredPersons ||
                      state.injured_people.find(
                        (people: any) =>
                          !people.description && people.type === 'no_familiar'
                      ) ||
                      !!Object.keys(errors).length
                }
                onClick={callNextStep}
              >
                Continuar
              </FloatingButton>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default InjuredPersons;
